import apiClient from './client';

export const fetchScoredRedFlags = async (caseNumber) => {
  const { data } = await apiClient.get(`/api/cases/${caseNumber}/scored-red-flags`);
  return data; // { flags: [...], total, summary: { validated, unvalidated, rejected } }
};

export const validateScoredRedFlag = async (flagId, payload) => {
  const { data } = await apiClient.patch(
    `/api/scored-red-flags/${flagId}/validate`,
    payload,
  );
  return data;
};
